import ArrowUpRightIcon from "@redotech/redo-icons/arrow-circle-up-right.svg";
import { RedoIcon } from "@redotech/redo-web/arbiter-components/icon/redo-icon";
import { memo, useCallback, useState } from "react";
import { DecryptedText } from "./decrypted-text";
import * as styles from "./login-modal.module.css";

function getLoginUrl(): string {
  const next = encodeURIComponent("/onboarding-redirect");
  if (typeof window === "undefined") {
    return `https://app.getredo.com/login?next=${next}`;
  }
  const hostname = window.location.hostname;
  if (hostname === "localhost") {
    return `http://localhost:13003/login?next=${next}`;
  }
  if (hostname.endsWith(".getredo.localhost")) {
    return `https://app-vite.getredo.localhost/login?next=${next}`;
  }
  return `https://app.getredo.com/login?next=${next}`;
}

const LOGIN_URL = getLoginUrl();

const BACKGROUND_IMAGE =
  "https://redoapi-dev.s3.amazonaws.com/redo/static/onboarding-v2/onboarding-v2-login-1-2.webp";

export const LoginModal = memo(function LoginModal() {
  const [loaded, setLoaded] = useState(false);
  const handleLoad = useCallback(() => setLoaded(true), []);

  if (!loaded) {
    return (
      <img
        alt=""
        onError={handleLoad}
        onLoad={handleLoad}
        src={BACKGROUND_IMAGE}
        style={{ display: "none" }}
      />
    );
  }

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <img alt="" className={styles.image} src={BACKGROUND_IMAGE} />
        <div className={styles.header}>
          <h2 className={styles.title}>
            <DecryptedText sequential speed={60} text="Session expired" />
          </h2>
          <p className={styles.subtitle}>
            Your setup session has expired. Log back into Redo, click your
            profile icon in the bottom left, and re-initiate a setup session.
          </p>
        </div>
        <a className={styles.link} href={LOGIN_URL}>
          Log in
          <RedoIcon className={styles.arrow} Icon={ArrowUpRightIcon} />
        </a>
      </div>
    </div>
  );
});
